export const LOGIN_PATH = `/_hcms/mem/login`;
export const TICKET_BASE_PATH = `/_hcms/customerportal/v1/ticket`;
export const TICKET_EXPORT_CSV_PATH = `${TICKET_BASE_PATH}/export/csv`;
export const FILE_MANAGER_BASE_PATH = `/_hcms/customerportal/filemanager`;
export const TICKET_RELEVANT_THREADS_BASE_PATH = `/_hcms/customerportal/v1/threadview/relevant-threads`;
export const THREAD_ATTACHMENTS_BASE_PATH = `/_hcms/customerportal/v1/attachment/thread`;

/* == Preview Endpoints == */